import formatName from 'I18n/utils/formatName';
import styled from 'styled-components';
import FormattedName from 'I18n/components/FormattedName';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error has no declaration file at the moment
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { getContactLink } from '../../../url/getContactLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "ContactInSystemSection__StyledUIFlex",
  componentId: "sc-18v3fow-0"
})(["display:inherit;margin-top:10px;"]);
const ContactSection = styled(UIFlex).withConfig({
  displayName: "ContactInSystemSection__ContactSection",
  componentId: "sc-18v3fow-1"
})(["margin-top:10px;"]);
const StyledUILink = styled(UILink).withConfig({
  displayName: "ContactInSystemSection__StyledUILink",
  componentId: "sc-18v3fow-2"
})(["align-self:center;"]);
const ContactInSystemSection = ({
  firstName,
  lastName,
  vid,
  email
}) => {
  const displayName = firstName === undefined && lastName === undefined ? email : formatName({
    firstName,
    lastName
  });
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    direction: "column",
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.contact-promotion-modal.emailFound.stepTwoLabel',
      options: {
        emailAddress: email
      }
    }), /*#__PURE__*/_jsxs(ContactSection, {
      gap: 10,
      children: [/*#__PURE__*/_jsx(UIAvatar, {
        email: email,
        vid: vid,
        displayName: displayName
      }), /*#__PURE__*/_jsx(StyledUILink, {
        external: true,
        href: getContactLink(vid),
        children: /*#__PURE__*/_jsx(FormattedName, {
          email: email,
          givenName: firstName,
          familyName: lastName
        })
      })]
    })]
  });
};
ContactInSystemSection.displayName = 'ContactInSystemSection';
export default ContactInSystemSection;